import { Link } from "react-router-dom";
import Logo from "../../icons/NuevoLogoPiSeun.png";
import panelPrincipal from "./panel-principal.png";
import "./tutorial.css";

export default function TutorialPanelPrincipal() {
  return (
    <main className="tutorial-page">
      <nav className="tutorial-nav" aria-label="Navegación del instructivo">
        <Link to="/home" className="tutorial-brand" aria-label="Volver al panel principal">
          <img src={Logo} alt="" />
          <span>PiSeun</span>
        </Link>
        <Link to="/home" className="tutorial-back">
          <i className="pi pi-arrow-left" aria-hidden="true" /> Volver al panel
        </Link>
      </nav>

      <header className="tutorial-hero">
        <div className="tutorial-hero-content">
          <span className="tutorial-kicker">Guía de navegación</span>
          <h1>Conocé el panel principal</h1>
          <p>Aprendé a encontrar rápidamente cada área y funcionalidad de PiSeun.</p>
          <div className="tutorial-jump-links" aria-label="Secciones del instructivo">
            <a href="#panel">Panel principal</a>
            <a href="#formas-acceso">Formas de acceso</a>
            <a href="#permisos">Permisos</a>
          </div>
        </div>
        <div className="tutorial-hero-mark" aria-hidden="true">
          <i className="pi pi-th-large" />
        </div>
      </header>

      <div className="tutorial-content">
        <section id="panel" className="tutorial-section">
          <span className="tutorial-section-label">Tu punto de partida</span>
          <h2>Panel principal</h2>
          <p>
            Al ingresar a PiSeun accedés al Panel Principal, desde donde podés navegar
            por las distintas funcionalidades del sistema.
          </p>
          <figure className="tutorial-panel-figure">
            <img src={panelPrincipal} alt="Panel principal de PiSeun con el menú lateral y cuatro accesos principales" />
            <figcaption>Vista general del panel principal de PiSeun.</figcaption>
          </figure>
        </section>

        <section id="formas-acceso" className="tutorial-section">
          <span className="tutorial-section-label">Navegación</span>
          <h2>Dos formas de acceder</h2>
          <p>
            PiSeun ofrece dos caminos para llegar a las distintas áreas del sistema.
            Podés elegir el que resulte más cómodo para la tarea que necesitás realizar.
          </p>
          <div className="tutorial-access-grid">
            <article>
              <span className="tutorial-access-number">1</span>
              <div>
                <span className="tutorial-section-label">Desde el centro</span>
                <h3>Accesos principales</h3>
                <p>
                  Agrupan las funcionalidades por tipo de operación. Al seleccionar uno,
                  se muestran todas las opciones disponibles dentro de esa área.
                </p>
                <ul>
                  <li><i className="pi pi-box" aria-hidden="true" /> Gestión de producción</li>
                  <li><i className="pi pi-shopping-cart" aria-hidden="true" /> Ventas</li>
                  <li><i className="pi pi-chart-bar" aria-hidden="true" /> Consultas</li>
                  <li><i className="pi pi-cog" aria-hidden="true" /> Catálogo y configuración</li>
                </ul>
              </div>
            </article>
            <article>
              <span className="tutorial-access-number">2</span>
              <div>
                <span className="tutorial-section-label">Acceso directo</span>
                <h3>Menú lateral</h3>
                <p>
                  Permite ingresar directamente a cada funcionalidad, sin necesidad de
                  pasar primero por los accesos principales.
                </p>
                <div className="tutorial-menu-example" aria-label="Ejemplo del menú lateral">
                  <span><i className="pi pi-home" aria-hidden="true" /> Inicio</span>
                  <small>Gestión de producción</small>
                  <span><i className="pi pi-sign-in" aria-hidden="true" /> Ingresos a planta</span>
                  <span><i className="pi pi-box" aria-hidden="true" /> Producción</span>
                  <span><i className="pi pi-truck" aria-hidden="true" /> Despachos</span>
                </div>
              </div>
            </article>
          </div>
        </section>

        <section id="permisos" className="tutorial-section">
          <div className="tutorial-heading">
            <span className="tutorial-step"><i className="pi pi-shield" aria-hidden="true" /></span>
            <div><span className="tutorial-section-label">Acceso personalizado</span><h2>Opciones según tus permisos</h2></div>
          </div>
          <p>
            Las opciones disponibles tanto en el panel como en el menú lateral dependen
            de los permisos asignados a cada usuario. Por eso, es posible que no todas las
            personas vean exactamente los mismos accesos.
          </p>
          <div className="tutorial-note tutorial-note-neutral">
            <i className="pi pi-info-circle" aria-hidden="true" />
            <p>Si necesitás acceder a una opción que no aparece, consultá con el administrador de tu cuenta.</p>
          </div>
        </section>

        <section className="tutorial-ready">
          <i className="pi pi-check-circle" aria-hidden="true" />
          <div><h2>Ya podés empezar</h2><p>Volvé al panel y elegí el acceso que corresponda a tu tarea.</p></div>
          <Link to="/home">Ir al panel principal</Link>
        </section>
      </div>

      <footer className="tutorial-footer">PiSeun · Gestión simple para tu negocio</footer>
    </main>
  );
}
